import React from "react";

import { useIntl, FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { useTheme } from "styled-components";

import Button from "ds/Button";
import { selectCurrentUserUsername } from "Reducers/app/selectors";
import Illustration from "Vendor_resources/images/empty-profiling.svg";
import IllustrationDark from "Vendor_resources/images/empty-profiling_dark.svg";

import * as S from "./NotFound.styles";

type NotFoundProps = {
  title?: string;
  description?: string;
  illustration?: React.ReactNode;
  enableCta?: boolean;
  children?: React.ReactNode;
};

const NotFound = (props: NotFoundProps) => {
  const intl = useIntl();
  const theme = useTheme();

  const defaultTitle = intl.formatMessage({
    id: "something_went_wrong"
  });

  const defaultDescription = intl.formatMessage({
    id: "resources_not_found"
  });

  const username = useSelector(selectCurrentUserUsername);
  const notFoundImage = theme.name === "dark" ? IllustrationDark : Illustration;

  const {
    title,
    description,
    enableCta = true,
    illustration,
    children
  } = props;

  return (
    <S.Layout>
      <S.Illustration>
        <img
          src={illustration || notFoundImage}
          alt={intl.formatMessage({ id: "something_went_wrong" })}
        />
      </S.Illustration>
      <S.Title tag="h3">{title || defaultTitle}</S.Title>
      {children || (
        <>
          <S.Paragraph>{description || defaultDescription}</S.Paragraph>
          {enableCta && (
            <FormattedMessage
              id="metrics.error.generic.link"
              values={{
                a: (...chunks) => (
                  <Button
                    analyticId="metrics.error.generic.link"
                    variant="link"
                    target="_blank"
                    to={`/-/users/${username}/tickets/open`}
                  >
                    {chunks}
                  </Button>
                )
              }}
            />
          )}
        </>
      )}
    </S.Layout>
  );
};

export default NotFound;
